import { PATH_DASHBOARD } from '../../../routes/paths';
import Iconify from '../../../components/Iconify';

const icon = (name) => <Iconify icon={name} sx={{ width: 1, height: 1 }} />;

const navConfig = [
  {
    subheader: 'admin shell',
    items: [
      {
        title: 'Dashboard',
        path: PATH_DASHBOARD.dashboard.root,
        icon: icon('solar:widget-5-bold'),
      },
      {
        title: 'Users',
        path: PATH_DASHBOARD.users.root,
        icon: icon('solar:users-group-rounded-bold'),
        requiredModule: 'users',
        children: [
          { title: 'All Users', path: PATH_DASHBOARD.users.allUsers },
          { title: 'Wallet Balances', path: PATH_DASHBOARD.users.walletBalances },
          { title: 'Primary Account', path: PATH_DASHBOARD.users.primaryAccount },
        ],
      },
      {
        title: 'Transactions',
        path: PATH_DASHBOARD.transactions.root,
        icon: icon('solar:card-transfer-bold'),
        requiredModule: 'transactions',
        children: [
          { title: 'General History', path: PATH_DASHBOARD.transactions.history },
          { title: 'Blockchain Deposits', path: PATH_DASHBOARD.transactions.blockchain },
          { title: 'Instant Swaps', path: PATH_DASHBOARD.transactions.instantSwaps },
          { title: 'Bank Transfer Attempt', path: PATH_DASHBOARD.transactions.history },
        ],
      },
      {
        title: 'Risk & Policy',
        path: PATH_DASHBOARD.riskPolicy.root,
        icon: icon('solar:shield-warning-bold'),
        requiredModule: 'risk',
        children: [
           //@todo - make each section here a stand alone component
          { title: 'Summary', path: PATH_DASHBOARD.riskPolicy.summary },
          { title: 'Decision Logs', path: PATH_DASHBOARD.riskPolicy.decisionLogs },
          { title: 'Thresholds', path: PATH_DASHBOARD.riskPolicy.thresholds },
          { title: 'Simulator', path: PATH_DASHBOARD.riskPolicy.simulator },
        ],
      },
      {
        title: 'Blockchain Ops',
        path: PATH_DASHBOARD.blockchainOps.root,
        icon: icon('solar:database-bold'),
        requiredModule: 'services',
        children: [
          { title: 'By Blockchain Tx', path: PATH_DASHBOARD.blockchainOps.blockchainTx },
          { title: 'By Quote', path: PATH_DASHBOARD.blockchainOps.quote },
          { title: 'By Lens Transaction', path: PATH_DASHBOARD.blockchainOps.transaction },
        ],
      },
      {
        title: 'Queue & Jobs',
        path: PATH_DASHBOARD.queueJobs.root,
        icon: icon('solar:server-square-update-bold'),
        requiredModule: 'queues',
        children: [
          //@todo create a signle file QueueJobsOverview component for the PATH_DASHBOARD.queueJobs.overview 
          { title: 'Overview', path: PATH_DASHBOARD.queueJobs.overview },
          //@todo create a signle file QueueJobsList component for the [PATH_DASHBOARD.queueJobs.queued, PATH_DASHBOARD.queueJobs.reserved, PATH_DASHBOARD.queueJobs.failed]
          // when user navigate to [failed,queued,reserved] the component uses status from the url to load the various list
          { title: 'Queued', path: PATH_DASHBOARD.queueJobs.queued },
          { title: 'Reserved', path: PATH_DASHBOARD.queueJobs.reserved },
          { title: 'Failed', path: PATH_DASHBOARD.queueJobs.failed },
           //@todo create a signle file QueueOutBox component for the PATH_DASHBOARD.queueJobs.outbox 
          { title: 'Outbox', path: PATH_DASHBOARD.queueJobs.outbox },
        ],
      },
      {
        title: 'Service Reports',
        path: PATH_DASHBOARD.serviceReports.root,
        icon: icon('solar:monitor-smartphone-bold'),
        requiredModule: 'services',
        children: [
          //@todo - make each section here a stand alone component
          { title: 'Overview', path: PATH_DASHBOARD.serviceReports.overview },
          { title: 'Incidents', path: PATH_DASHBOARD.serviceReports.incidents },
        ],
      },
      {
        title: 'SOS',
        path: PATH_DASHBOARD.sos.root,
        icon: icon('solar:siren-rounded-bold'),
        requiredModule: 'sos',
        children: [
          { title: 'SOS Overview', path: PATH_DASHBOARD.sos.overview },
          { title: 'SOS Signals', path: PATH_DASHBOARD.sos.signals },
        ],
      },
      {
        title: 'Adjustments',
        path: PATH_DASHBOARD.adjustments.root,
        icon: icon('solar:calculator-bold'),
        requiredModule: 'adjustments',
        children: [
          //@todo create a request list
          { title: 'Requests', path: PATH_DASHBOARD.adjustments.list },
          //@todo create a single create new adjustment request
          { title: 'Create Request', path: PATH_DASHBOARD.adjustments.create },
        ],
      },
      {
        title: 'Access Control',
        path: PATH_DASHBOARD.accessControl.root,
        icon: icon('solar:shield-user-bold'),
        requiredModule: 'access',
        children: [
          { title: 'Requests', path: PATH_DASHBOARD.accessControl.requests },
          { title: 'Grants', path: PATH_DASHBOARD.accessControl.grants },
          { title: 'Audit', path: PATH_DASHBOARD.accessControl.audit },
        ],
      },
      {
        title: 'Config',
        path: PATH_DASHBOARD.config.root,
        icon: icon('solar:settings-bold'),
        requiredModule: 'config',
        children: [
          //@todo separate each one to its own component
          { title: 'Groups', path: PATH_DASHBOARD.config.groups },
          { title: 'Feature Flags', path: PATH_DASHBOARD.config.featureFlags },
          { title: 'Audit', path: PATH_DASHBOARD.config.audit },
          // @todo move thrid party threshold setting here and make it a stand alone component
        ],
      },
    ],
  },
  {
    subheader: 'legacy reference',
    items: [
      {
        title: 'Admin Management',
        path: PATH_DASHBOARD.legacy.adminManagement.root,
        icon: icon('solar:user-id-bold'),
        children: [{ title: 'Admin List', path: PATH_DASHBOARD.legacy.adminManagement.list }],
      },
      {
        title: 'Crypto Assets',
        path: PATH_DASHBOARD.legacy.cryptoAssets.root,
        icon: icon('solar:bitcoin-card-bold'),
        children: [
          { title: 'Assets List', path: PATH_DASHBOARD.legacy.cryptoAssets.list },
          { title: 'Exchange Ranges', path: PATH_DASHBOARD.legacy.cryptoAssets.ranges },
        ],
      },
      {
        title: 'Content',
        path: PATH_DASHBOARD.legacy.content.root,
        icon: icon('solar:document-text-bold'),
        children: [
          { title: 'Featured Posts', path: PATH_DASHBOARD.legacy.content.featuredPosts },
          { title: 'App Posts', path: PATH_DASHBOARD.legacy.content.appPosts },
        ],
      },
      {
        title: 'Cruise & Campaigns',
        path: PATH_DASHBOARD.legacy.cruiseCampaigns.root,
        icon: icon('solar:rocket-bold'),
        children: [
          { title: 'Cruise Overview', path: PATH_DASHBOARD.legacy.cruiseCampaigns.cruiseOverview },
          { title: 'Cruise Manage', path: PATH_DASHBOARD.legacy.cruiseCampaigns.cruiseManage },
          { title: 'Cruise Batch', path: PATH_DASHBOARD.legacy.cruiseCampaigns.cruiseBatch },
          { title: 'Cruise History', path: PATH_DASHBOARD.legacy.cruiseCampaigns.cruiseHistory },
          { title: 'Cruise Telemetry', path: PATH_DASHBOARD.legacy.cruiseCampaigns.cruiseTelemetry },
          { title: 'Campaigns', path: PATH_DASHBOARD.legacy.cruiseCampaigns.campaigns },
        ],
      },
      {
        title: 'Giftcard Operations',
        path: PATH_DASHBOARD.legacy.giftcardOperations.root,
        icon: icon('solar:gift-bold'),
        children: [{ title: 'Giftcard Orders', path: PATH_DASHBOARD.legacy.giftcardOperations.giftcardOrders }],
      },
      {
        title: 'Compliance',
        path: PATH_DASHBOARD.legacy.compliance.root,
        icon: icon('solar:clipboard-check-bold'),
        children: [
          { title: 'Queue', path: PATH_DASHBOARD.legacy.compliance.queue },
          { title: 'Primary Account', path: PATH_DASHBOARD.legacy.compliance.overview },
          { title: 'Overview', path: PATH_DASHBOARD.legacy.compliance.overview },
          { title: 'Health', path: PATH_DASHBOARD.legacy.compliance.health },
          { title: 'History', path: PATH_DASHBOARD.legacy.compliance.history },
        ],
      },
      {
        title: 'Legacy Users',
        path: PATH_DASHBOARD.legacy.userManagement.root,
        icon: icon('solar:user-bold'),
        children: [
          { title: 'User List', path: PATH_DASHBOARD.legacy.userManagement.list },
          { title: 'Wallet', path: PATH_DASHBOARD.legacy.userManagement.wallet },
        ],
      },
      {
        title: 'System Reports',
        path: PATH_DASHBOARD.legacy.systemReports.root,
        icon: icon('solar:chart-bold'),
        children: [
          { title: 'Variables', path: PATH_DASHBOARD.legacy.systemReports.variables },
          { title: 'Referral Ranking', path: PATH_DASHBOARD.legacy.systemReports.referralRanking },
          { title: 'Monthly Bonus', path: PATH_DASHBOARD.legacy.systemReports.monthlyBonus },
          { title: 'Activity Log', path: PATH_DASHBOARD.legacy.systemReports.activities },
        ],
      },
      {
        title: 'Legacy Blockchain',
        path: PATH_DASHBOARD.legacy.blockchainViews.root,
        icon: icon('solar:database-bold'),
        children: [
          { title: 'Quidax Accounts', path: PATH_DASHBOARD.legacy.blockchainViews.quidaxAccounts },
          { title: 'Wallet Addresses', path: PATH_DASHBOARD.legacy.blockchainViews.walletAddresses },
          { title: 'Instant Swaps', path: PATH_DASHBOARD.legacy.blockchainViews.instantSwaps },
        ],
      },
    ],
  },
];

export default navConfig;
